module.exports = "<div class=landing-screen__contents> <div class=landing-screen__contents__enter> <div class=logo-container style=\"background:url({{$ctrl.AppServices.DataManager.config.settings.localizedPath}}images/localized/landing_logo.png) no-repeat\"></div> <div class=\"start-button pointerfix\" hm-tap=$ctrl.onClick()></div> <div class=start-button-overlay> <img ng-src={{$ctrl.AppServices.DataManager.config.settings.assetsPath}}landing-screen/PLAY_BTN_OVERLAY.png alt=\"\"/> </div> </div> </div> ";


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/landing-screen/landing-screen.html
 ** module id = 84
 ** module chunks = 0
 **/